import { render, staticRenderFns } from "./ADescuentoReversion.vue?vue&type=template&id=5c26da52"
import script from "./ADescuentoReversion.vue?vue&type=script&lang=js"
export * from "./ADescuentoReversion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports